export * from './ProductDetailBrandCornerSection';
